/**
 * Created by roman.kupin on 4/20/2017.
 */
// @ts-ignore
const EventEmitter = require("wolfy87-eventemitter");

export const SharedEvents = new EventEmitter();
